export const dashboardConstants = {
  DETAIL_REQUEST: 'DASHBOARD_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'DASHBOARD_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'DASHBOARD_DETAIL_FAILURE'
};
